import { MaterialLayout, ExtendedPart, ProcessStep, ProductLine, QuoteRequestLine } from "../types";
import { IndustrialProcess } from "../types/IndustrialProcess";
import { OptimizedMachineTimes } from "./computeOptimizedMachineTimes";
import { computeProcessPrice } from "./computeProcessPrice";

export type ComputeQuoteRequestLineTransportQuoteRequestLine = QuoteRequestLine & {
  processSteps: (ProcessStep & {
    materialLayout: MaterialLayout | null;
    productLines: ProductLine[];
  })[];
  part: ExtendedPart;
};

export const computeQuoteRequestLineTransport = (
  quoteRequestLine: ComputeQuoteRequestLineTransportQuoteRequestLine,
  optimizedMachineTimes: OptimizedMachineTimes,
) => {
  const { quantity, part, processSteps } = quoteRequestLine;

  const transportProcesses = processSteps.filter(
    (process) => process.industrialProcess === IndustrialProcess.TRANSPORT,
  );

  if (transportProcesses.length === 0) {
    return {
      transportProcessesCost: 0,
      transportProcessesPrice: 0,
      transportProcessesMargin: 0,
    };
  }

  let transportProcessesCost = 0;
  let transportProcessesMargin = 0;
  let transportProcessesPrice = 0;

  transportProcesses.forEach((process) => {
    const { partProcessPrice, partProcessCost, partProcessMarginPrice } = computeProcessPrice({
      quantity,
      quantityInAssembly: part.quantityInAssembly,
      reworkRatio: quoteRequestLine.reworkRatio,
      processStep: process,
      optimizedMachineTimes,
    });

    transportProcessesCost += partProcessCost * quantity;
    transportProcessesMargin += partProcessMarginPrice * quantity;
    transportProcessesPrice += partProcessPrice * quantity;
  });

  return {
    transportProcessesCost,
    transportProcessesMargin,
    transportProcessesPrice,
  };
};
